import React from "react";
import ReactDOM from "react-dom/client";
import Construction from "./construction";
import "../../index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Construction />
  </React.StrictMode>,
);
